import React, { useEffect, useState } from "react";
import { formatLiquidCrystalDateTime } from "../../utils/liquidCrystalClockFormat";
import "./LiquidCrystalClock.css";

/**
 * Digital LCD-style clock — same format/behavior as the original moment + setInterval example.
 * @param {{ className?: string; id?: string }} props
 */
function LiquidCrystalClock({ className = "", id }) {
  const [display, setDisplay] = useState(() => formatLiquidCrystalDateTime(new Date()));

  useEffect(() => {
    const tick = () => setDisplay(formatLiquidCrystalDateTime(new Date()));
    tick();
    const intervalId = setInterval(tick, 1000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div id={id} className={`clock liquid-crystal-clock ${className}`.trim()}>
      {display}
    </div>
  );
}

export default LiquidCrystalClock;
